import { Pipe, PipeTransform } from '@angular/core';
import { genericStringFormatter, storageConverterRender } from '../../../dataprotection-common/common-renderers';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';

@Pipe({name: 'storageRenderPipe'})
export class StorageRenderPipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    transform(value): any {
        if (value && value > 0) {
            return storageConverterRender(value, 'MB');
        }
        else {
            return "0 MB";
        }
    }
}

@Pipe({name: 'statusStringFormatterPipe'})
export class StatusStringFormatterPipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }

    transform(value): any {
        if (value) {
            if (value === "success") {
                return this.translate.instant('vcDpsModule.restorePoints.grid.message.success');
            } else if (value === "failed") {
                return this.translate.instant('vcDpsModule.restorePoints.grid.message.failure');
            } else if (value === "partialSuccess") {
                return this.translate.instant('vcDpsModule.restorePoints.grid.message.partialSuccess');
            } else {
                return value;
            }
        } else {
            return "-";
        }
    }
}

@Pipe({name: 'dateRendererPipe'})
export class DateRendererPipe implements PipeTransform {
    transform(value): any {
        if (value) {
            return new Date(value);
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/restore-points/restore-points.pipe.ts